// Method to format a number as a string left padded with zeros
// where numDigits is the desired number of digits to pad to
// leftPadWithZeros(9,2) => '09'
// leftPadWithZeros(21,4) => '0021'
// leftPadWithZeros(999,2) => '999'
const leftPadWithZeros = (number, numDigits) => {
  const numberStr = `${number}`;
  const numZeros = numDigits - numberStr.length;
  if (numZeros < 1) {
    return numberStr;
  }
  // create a string of numZero zeros. E.G '00'
  const zeros = Array(numZeros).fill('0').join('');
  return `${zeros}${numberStr}`;
};

export { leftPadWithZeros };
